import { mergeTemplate } from './base-template';

export const treuhandTemplate = mergeTemplate({
  name: 'Treuhand (Allround)',
  icon: '🧾',
  settings: {
    primaryColor: '#1a365d',
    accentColor: '#38a169',
    fontStack: 'instrument',
    darkModeToggle: false,
    stylePreset: 'swiss',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Unsere Treuhand-Dienstleistungen',
      heroSubtitle: 'Massgeschneiderte Lösungen für Ihre finanzielle Sicherheit',
      packages: [
        { name: 'Buchhaltung', price: 'ab CHF 350/Mt.', description: 'Laufende Finanzbuchhaltung und Reporting', features: 'Fibu, Debitoren/Kreditoren, MWST-Abrechnung, Quartals-Report', highlighted: false },
        { name: 'Steuerberatung', price: 'ab CHF 600/Mt.', description: 'Steuerplanung und -optimierung', features: 'Steuererklärung, Steuerplanung, Ruling-Anfragen, Jahresabschluss', highlighted: true },
        { name: 'Revision & Beratung', price: 'auf Anfrage', description: 'Prüfung und strategische Beratung', features: 'Eingeschränkte Revision, Bewertungen, Nachfolgeplanung, Due Diligence', highlighted: false },
      ],
      ctaTitle: 'Vertrauen Sie auf Erfahrung',
      ctaText: 'Vereinbaren Sie ein unverbindliches Erstgespräch mit unseren Treuhand-Experten.',
      ctaButtonText: 'Erstgespräch vereinbaren',
    },
    pageMethoden: {
      heroTitle: 'Unser Vorgehen',
      heroSubtitle: 'Strukturiert, transparent, auf Ihre Bedürfnisse zugeschnitten',
      introText: 'Von der Mandatsübernahme bis zum laufenden Reporting — wir arbeiten nach bewährten Prozessen mit persönlicher Betreuung.',
      steps: [
        { title: 'Mandatsübernahme', description: 'Bestandsaufnahme Ihrer Finanzsituation und bisherigen Unterlagen' },
        { title: 'Analyse & Planung', description: 'Definition von Zielen, Prozessen und Zuständigkeiten' },
        { title: 'Laufende Betreuung', description: 'Regelmässige Buchführung, Abstimmungen und Beratung' },
        { title: 'Reporting & Review', description: 'Quartals- und Jahresberichte mit konkreten Empfehlungen' },
      ],
      tools: [
        { name: 'Bexio', description: 'Cloud-Buchhaltung und Faktura' },
        { name: 'Abacus', description: 'Professionelle ERP-Lösung' },
        { name: 'KLARA', description: 'Lohn und Sozialversicherungen' },
      ],
      philosophyTitle: 'Unsere Treuhand-Philosophie',
      philosophyText: 'Wir verstehen uns als langfristiger Partner — nicht als austauschbarer Dienstleister. Qualität, Diskretion und proaktive Beratung sind unser Fundament.',
    },
    pageUeberMich: {
      heroTitle: 'Unsere Kanzlei',
      heroSubtitle: 'Erfahrung, Kompetenz und Vertrauen seit über 20 Jahren',
      introText: 'Als etablierte Treuhandgesellschaft betreuen wir Unternehmen und Privatpersonen in allen Bereichen des Finanz- und Rechnungswesens.',
      imageUrl: '',
      timeline: [
        { year: '2003', text: 'Gründung der Treuhand Muster AG' },
        { year: '2012', text: 'Erweiterung um Steuerberatung' },
        { year: '2020', text: 'Digitalisierung aller Prozesse' },
      ],
      values: [
        { title: 'Diskretion', description: 'Absolute Vertraulichkeit in allen Mandaten' },
        { title: 'Kompetenz', description: 'Kontinuierliche Weiterbildung und Spezialisierung' },
        { title: 'Partnerschaft', description: 'Langfristige Beziehungen statt kurzfristiger Aufträge' },
      ],
      certifications: 'Treuhand Suisse, Revisionsexperte RAB, EXPERTsuisse',
    },
  },
  components: {
    header: {
      companyName: 'Treuhand Muster AG',
      logoText: 'TM',
      navItems: ['Leistungen', 'Methoden', 'Team', 'Kontakt'],
      ctaText: 'Erstgespräch buchen',
    },
    hero: {
      title: 'Ihr Treuhänder – persönlich. kompetent. digital.',
      subtitle:
        'Buchhaltung, Steuern und Lohn – terminsicher und verständlich.',
      primaryBtn: 'Kostenloses Erstgespräch',
      secondaryBtn: 'Leistungen',
      imageUrl: '',
    },
    trust: {
      items: [
        { value: 'DSG/DSGVO', label: 'Datenschutz' },
        { value: 'Audit-Trail', label: 'Nachvollziehbar' },
        { value: 'Digital', label: 'Cloud-ready' },
        { value: 'Persönlich', label: 'Fixer Kontakt' },
      ],
    },
    authority: {
      title: 'Vertrauen & Standards',
      variant: 'badges',
      items: [
        {
          icon: '🏅',
          text: 'Verbandsmitgliedschaften (z. B. TREUHAND|SUISSE)',
        },
        {
          icon: '🎓',
          text: 'Aus- und Weiterbildungen (Diplome/Zertifikate)',
        },
        { icon: '🛡️', text: 'Berufshaftpflicht / Sorgfaltspflichten' },
      ],
    },
    services: {
      title: 'Leistungen',
      subtitle: 'Ein Treuhand-Setup, das zu Ihrem Alltag passt.',
      items: [
        {
          icon: '📊',
          title: 'Buchhaltung',
          text: 'Fibu, Debi/Kredi, Abschlüsse – klar strukturiert und effizient.',
        },
        {
          icon: '🧾',
          title: 'Steuern',
          text: 'Erklärungen, MWST, Planung – verständlich erklärt, sauber eingereicht.',
        },
        {
          icon: '👥',
          title: 'Lohn',
          text: 'Lohnabrechnungen, Quellensteuer, Sozialversicherungen – terminsicher.',
        },
        {
          icon: '🧠',
          title: 'Beratung',
          text: 'Gründung, Struktur, Nachfolge – pragmatisch und vorausschauend.',
        },
      ],
    },
    proofTable: {
      title: 'Was Sie gewinnen',
      subtitle:
        'Vergleich: mit professioneller Treuhand vs. \u201Eselbst lösen\u201C.',
      headers: ['Kriterium', 'Mit Treuhand', 'Selbst/Ad-hoc'],
      highlightColumn: 1,
      rows: [
        {
          criterion: 'Fristen & Compliance',
          us: 'Strukturierter Prozess, klare Verantwortung',
          other: 'Abhängig von Zeit/Know-how',
        },
        {
          criterion: 'Transparenz',
          us: 'Nachvollziehbar dokumentiert',
          other: 'Wissen verteilt / Personenabhängig',
        },
        {
          criterion: 'Entscheidungsgrundlagen',
          us: 'Sinnvolle Reports & Interpretation',
          other: 'Zahlen vorhanden, aber ohne Kontext',
        },
        {
          criterion: 'Risiko',
          us: 'Reduziert durch Review und Standards',
          other: 'Fehler-/Nachzahlungsrisiko',
        },
      ],
    },
    process: {
      title: 'So arbeiten wir',
      subtitle: 'Klarer Ablauf, wenig Reibung, sauberer Audit-Trail.',
      steps: [
        {
          num: '1',
          title: 'Erstgespräch',
          text: 'Ziele, Umfang, Fristen und Tools klären.',
        },
        {
          num: '2',
          title: 'Setup',
          text: 'Zugänge, Ablage, Prozesse und Verantwortlichkeiten definieren.',
        },
        {
          num: '3',
          title: 'Laufende Betreuung',
          text: 'Buchen, prüfen, abstimmen – mit proaktiven Hinweisen.',
        },
        {
          num: '4',
          title: 'Abschluss & Planung',
          text: 'Jahresabschluss, Steuern und Optimierungsschritte vorbereiten.',
        },
      ],
    },
    benefits: {
      title: 'Warum Mandanten bleiben',
      subtitle: 'Weil es im Alltag funktioniert.',
      items: [
        {
          title: 'Verlässlichkeit',
          text: 'Termine, Antworten und Ergebnisse – planbar und sauber.',
        },
        {
          title: 'Verständlichkeit',
          text: 'Wir übersetzen Zahlen in Entscheidungen.',
        },
        {
          title: 'Digitale Zusammenarbeit',
          text: 'So viel Automation wie sinnvoll – ohne Kontrollverlust.',
        },
      ],
    },
    team: {
      title: 'Ihr Team',
      subtitle: 'Persönliche Ansprechpartner mit Fachkompetenz.',
      members: [
        {
          name: 'Max Muster',
          role: 'Treuhandexperte',
          image: '',
          bio: 'Buchhaltung, Abschluss, Beratung.',
        },
        {
          name: 'Laura Beispiel',
          role: 'Steuern',
          image: '',
          bio: 'Natürliche und juristische Personen, MWST.',
        },
        {
          name: 'Noah Demo',
          role: 'Lohn & Sozialversicherungen',
          image: '',
          bio: 'Lohn, Quellensteuer, Deklarationen.',
        },
      ],
    },
    testimonials: {
      title: 'Mandantenstimmen',
      items: [
        {
          quote:
            'Endlich ist alles sauber – und ich weiss, wo ich stehe.',
          author: 'A. Keller',
          role: 'KMU-Inhaber',
        },
        {
          quote: 'Digital, schnell und trotzdem persönlich erreichbar.',
          author: 'J. Steiner',
          role: 'Co-Founder',
        },
        {
          quote: 'Die Steuerplanung hat uns im ersten Jahr bereits mehrere tausend Franken gespart. Absolut kompetent.',
          author: 'M. Brunner',
          role: 'Geschäftsführerin, Handels-GmbH',
        },
        {
          quote: 'Wir schätzen die proaktive Kommunikation — Fristen werden nie vergessen, und wir fühlen uns bestens betreut.',
          author: 'R. Widmer',
          role: 'Inhaber, Architekturbüro',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: 'Die häufigsten Fragen zur Zusammenarbeit.',
      items: [
        {
          question: 'Welche Unterlagen braucht ihr?',
          answer:
            'Je nach Umfang: Bankzugang/Exports, Belege, Verträge, Lohnstammdaten, MWST-Infos. Wir geben eine klare Checkliste.',
        },
        {
          question: 'Arbeitet ihr mit Bexio/Abacus/KLARA?',
          answer:
            'Wir richten uns nach Ihrem Setup oder empfehlen pragmatisch eine passende Lösung.',
        },
        {
          question: 'Wie schnell kann es losgehen?',
          answer:
            'Nach Erstgespräch und Setup typischerweise kurzfristig – abhängig von Zugängen und Datenlage.',
        },
        {
          question: 'Was kostet ein Erstgespräch?',
          answer:
            'Das Erstgespräch ist kostenlos und unverbindlich. Wir besprechen Ihre Situation und erstellen danach eine transparente Offerte.',
        },
      ],
    },
    cta: {
      title: 'Kostenloses Erstgespräch',
      subtitle:
        'Sagen Sie uns kurz, wo Sie stehen – wir schlagen die nächsten Schritte vor.',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
    stickyCta: {
      text: 'Fragen zu Buchhaltung oder Steuern?',
      buttonText: 'Rückruf anfordern',
      phone: '+41 00 000 00 00',
      note: 'Diskret & unverbindlich',
    },
    footer: {
      companyName: 'Treuhand Muster AG',
      tagline: 'Treuhand für KMU, Start-ups und Privatpersonen.',
      address: 'Musterweg 12, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
      linkedin: '',
      facebook: '',
      instagram: '',
    },
  },
});
